import { Stack, Button as MuiButton } from '@mui/material';
import { InlineBackdrop } from '@client/components/common/Backdrop';

export const PreviewCTA = () => (
  <InlineBackdrop color="success">
    <Stack spacing={2}>
      <MuiButton
        variant="contained"
        size="large"
        color="success"
        fullWidth
        disabled
      >
        Tickets
      </MuiButton>

      <MuiButton
        variant="outlined"
        size="large"
        color="success"
        fullWidth
        disabled
      >
        Share
      </MuiButton>
    </Stack>
  </InlineBackdrop>
);
